var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c(
          "div",
          { staticClass: "flex flex-col gap-4" },
          [
            _c("validation-observer", {
              ref: "validator",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var valid = ref.valid
                    return [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.createOrUpdate($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "vx-row" }, [
                            _c("div", { staticClass: "vx-col w-8/12" }, [
                              _vm.isEdit()
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "portal_cebas.credentialing.legal_entity"
                                            ),
                                            "label-for":
                                              "credentialing_config_legal_entity"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              id:
                                                "credentialing_config_legal_entity",
                                              name:
                                                "credentialing_config_legal_entity",
                                              readonly: ""
                                            },
                                            model: {
                                              value:
                                                _vm.model.legal_entity
                                                  .trading_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model.legal_entity,
                                                  "trading_name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.legal_entity.trading_name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c("validation-provider", {
                                        staticClass: "flex-grow",
                                        attrs: {
                                          name: _vm.$t(
                                            "portal_cebas.credentialing.legal_entity"
                                          ),
                                          rules: "required",
                                          slim: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  !_vm.isEdit()
                                                    ? _c("select-suggestion", {
                                                        staticClass: "required",
                                                        attrs: {
                                                          column:
                                                            "company_name,trading_name,cnpj",
                                                          model: "LegalEntity",
                                                          label:
                                                            "Pessoa Jurídica",
                                                          appendClearOption: true,
                                                          placeholderText:
                                                            "Digite o nome da instituição",
                                                          itemTextFormat:
                                                            _vm.legalEntityItemTextFormat
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedLegalEntity,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.selectedLegalEntity = $$v
                                                          },
                                                          expression:
                                                            "selectedLegalEntity"
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                            ])
                          ]),
                          _c("div", { staticClass: "vx-row pt-1" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t(
                                      "portal_cebas.credentialing.link"
                                    ),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "credentialing_config_link",
                                                  label: _vm.$t(
                                                    "portal_cebas.credentialing.link"
                                                  ),
                                                  "label-for":
                                                    "credentialing_config_link"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "required",
                                                  attrs: {
                                                    id:
                                                      "credentialing_config_link",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name:
                                                      "credentialing_config_link"
                                                  },
                                                  model: {
                                                    value: _vm.model.link,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "link",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "model.link"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:copy",
                                                        value: _vm.exemploLink,
                                                        expression:
                                                          "exemploLink",
                                                        arg: "copy"
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:success",
                                                        value: function() {
                                                          _vm.notifySuccess(
                                                            _vm.$vs,
                                                            "Cópia realizada com sucesso."
                                                          )
                                                        },
                                                        expression:
                                                          "() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}",
                                                        arg: "success"
                                                      },
                                                      {
                                                        name: "clipboard",
                                                        rawName:
                                                          "v-clipboard:error",
                                                        value: function() {
                                                          _vm.notifyError(
                                                            _vm.$vs,
                                                            "Não foi possível realizar a cópia."
                                                          )
                                                        },
                                                        expression:
                                                          "() => {notifyError($vs, 'Não foi possível realizar a cópia.')}",
                                                        arg: "error"
                                                      },
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top",
                                                        value: {
                                                          content:
                                                            "Copiar link completo",
                                                          delay: {
                                                            show: 100,
                                                            hide: 100
                                                          }
                                                        },
                                                        expression:
                                                          "{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}",
                                                        modifiers: { top: true }
                                                      }
                                                    ],
                                                    staticClass:
                                                      "align-left small w-full flex ml-1 text-break cursor-pointer pt-1 pb-2 gap-2"
                                                  },
                                                  [
                                                    _c("feather-icon", {
                                                      attrs: {
                                                        icon: "LinkIcon",
                                                        svgClasses:
                                                          "h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.exemploLink
                                                        ) +
                                                        " "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row" }, [
                            _c("div", { staticClass: "vx-col w-full" }, [
                              _c("label", { staticClass: "text-primary" }, [
                                _vm._v(
                                  " Link para consulta pública (protocolo): "
                                )
                              ]),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:copy",
                                      value: _vm.queryLinkPublicProtocol,
                                      expression: "queryLinkPublicProtocol",
                                      arg: "copy"
                                    },
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:success",
                                      value: function() {
                                        _vm.notifySuccess(
                                          _vm.$vs,
                                          "Cópia realizada com sucesso."
                                        )
                                      },
                                      expression:
                                        "() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}",
                                      arg: "success"
                                    },
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:error",
                                      value: function() {
                                        _vm.notifyError(
                                          _vm.$vs,
                                          "Não foi possível realizar a cópia."
                                        )
                                      },
                                      expression:
                                        "() => {notifyError($vs, 'Não foi possível realizar a cópia.')}",
                                      arg: "error"
                                    },
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top",
                                      value: {
                                        content: "Copiar link completo",
                                        delay: { show: 100, hide: 100 }
                                      },
                                      expression:
                                        "{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}",
                                      modifiers: { top: true }
                                    }
                                  ],
                                  staticClass:
                                    "align-left small w-full flex ml-1 text-break cursor-pointer pt-1 pb-2 gap-2"
                                },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "LinkIcon",
                                      svgClasses:
                                        "h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"
                                    }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.queryLinkPublicProtocol) +
                                      " "
                                  )
                                ],
                                1
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "vx-row pt-1" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c("validation-provider", {
                                  staticClass: "flex-grow",
                                  attrs: {
                                    name: _vm.$t(
                                      "portal_cebas.credentialing.title_page"
                                    ),
                                    rules: "required",
                                    slim: ""
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "portal_cebas.credentialing.title_page"
                                                  ),
                                                  "label-for":
                                                    "credentialing_config_title_page"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  staticClass: "required",
                                                  attrs: {
                                                    id:
                                                      "credentialing_config_title_page",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name:
                                                      "credentialing_config_title_page"
                                                  },
                                                  model: {
                                                    value: _vm.model.title_page,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "title_page",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.title_page"
                                                  }
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger"
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "portal_cebas.credentialing.info_page"
                                      ),
                                      "label-for": "content"
                                    }
                                  },
                                  [
                                    _c("complex-editor", {
                                      attrs: {
                                        editor_data: _vm.model.info_page
                                      },
                                      on: {
                                        "update:editor_data": function($event) {
                                          return _vm.$set(
                                            _vm.model,
                                            "info_page",
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "vx-row" }, [
                            _c(
                              "div",
                              { staticClass: "vx-col w-full mb-2" },
                              [
                                _c("vs-divider", { staticClass: "m-1" }, [
                                  _vm._v("Notificação para Interessados")
                                ]),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("receiving_emails"),
                                      "label-for": "emailsInput"
                                    }
                                  },
                                  [
                                    _c("emails-input", {
                                      ref: "emailsInput",
                                      attrs: {
                                        emailsInput: _vm.emailsInitialTag,
                                        sendButton: false
                                      },
                                      on: { emailsChanged: _vm.emailsChanged }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "w-full flex gap-2 justify-end" },
                        [
                          !_vm.isEdit()
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value:
                                        "portal_cebas.credentialing.config.create",
                                      expression:
                                        "'portal_cebas.credentialing.config.create'"
                                    }
                                  ],
                                  attrs: {
                                    variant: "primary",
                                    disabled: !valid
                                  },
                                  on: { click: _vm.createOrUpdate }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("action.save")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.isEdit()
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value:
                                        "portal_cebas.credentialing.config.edit",
                                      expression:
                                        "'portal_cebas.credentialing.config.edit'"
                                    }
                                  ],
                                  attrs: {
                                    variant: "primary",
                                    disabled: !valid
                                  },
                                  on: { click: _vm.createOrUpdate }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("action.save")) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "b-button",
                            {
                              staticClass: "float-right",
                              attrs: { variant: "outline-secondary" },
                              on: { click: _vm.goBack }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "CornerUpLeftIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v(_vm._s(_vm.$t("back")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }